<template>

    <v-content>
        <v-container fluid>
 
            <panelcontainer>
                <div class="headline" slot="headline">Müşteriler</div>
                <div slot="actions">
                    <v-btn tile color="indigo" dark @click="editItem()">
                        <v-icon>{{mdiPlus}}</v-icon> Yeni Müşteri Ekle
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Ürün listesi yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <table class="table table-striped table-borderless table-hover">
                        <thead>
                            <tr style="font-weight:300 !important"> 
                                <th colspan="2"><v-text-field :label="_label_author_name" v-model="filterTextName" outlined dense clearable hide-details placeholder="Ara"></v-text-field></th>
                                <th colspan="2"><v-text-field smallx :label="_label_author_name" v-model="filterTextCompany" outlined clearable dense hide-details placeholder="Ara"></v-text-field></th>  
                            </tr>
                            <tr>
                                <th width="20px">#</th>
                                <th>Kullanıcı</th>
                                <th>Firma</th> 
                                <th style="width:1%;" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(item, itemIndex) in getItems" :key="itemIndex" @click="editItem(item)">
                                <td class="cell-detail">
                                    1
                                </td>
                                <td class="cell-detail">
                                    <span><b>{{item.fullname}}</b></span>
                                    <span class="cell-detail-description">{{item.email}}</span>
                                </td>
                                <td class="cell-detail">
                                    <span><b>{{item.company.firma_adi}}</b></span>
                                    <span class="cell-detail-description">{{item.company.ilce}} / {{item.company.il}}</span>
                                </td> 
                                <td class="actions">
                                    <v-btn   small icon color="indigo" dark>
                                        <v-icon>{{mdiAccountEdit}}</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
                </template>
            </panelcontainer>
 
        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiAccountEdit,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiAccountEdit: mdiAccountEdit,

            isLoading: false, 
			items: [  ],
			filterTextName : "",
			filterTextCompany : "",
			_label_author_name : ""
		}),
		mounted(){
			this.loadItems();
		},
        methods: {
			loadItems(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/users/").then(response => {  
					this.items = response.body; 
					this.isLoading = false; 
				})  
			},
            editItem(item) {
				var link = "/users/edit/"
				if(item){
					link += "?id=" + item.id
				} 
				window.open(link, '_blank'); 
            },
            closeItem() {
                this.dialogEditor = false
            },
            askForRemove(item) {
                this.item = item;
                this.dialogEditor = false;
                this.dialogRemove = true;
            },
            closeForRemove() {
                this.dialogRemove = false;
            },
            saveItem() {

            },
            removeItem() {

            }
        },
        computed: {
            getItems() {
				var items = []; 
				var filterTextName = this.filterTextName == null || this.filterTextName == "" ? "" : this.filterTextName.seoUrl(); 
				var filterTextCompany = this.filterTextCompany == null || this.filterTextCompany == "" ? "" : this.filterTextCompany.seoUrl(); 
				items = this.items.filter( function(item) { 
					if((filterTextName != null && filterTextName != "")){
						if( 
							item.fullname.seoUrl().indexOf(filterTextName) < 0 && 
							item.email.seoUrl().indexOf(filterTextName) < 0 
						){ return false; }
					}
					if((filterTextCompany != null && filterTextCompany != "")){
						if( 
							item.company.firma_adi.seoUrl().indexOf(filterTextCompany) < 0 && 
							item.company.il.seoUrl().indexOf(filterTextCompany) < 0 && 
							item.company.ilce.seoUrl().indexOf(filterTextCompany) < 0 
						){ return false; }
					}
					return true;
				}) 
				return items;
            }
        }
    }
</script>

<style>

</style>